if (!customElements.get('main-account-login')) {
  class MainAccountLogin extends HTMLElement {
    constructor() {
      super();
      this.body = this.closest('body');
      this.hideHeader(document.URL);

      window.addEventListener('popstate', () => {
        this.hideHeader(document.URL);
      });
    }

    // Hide header for reset/recover password
    hideHeader(url) {
      if (url.includes('#recover')) {
        if (!this.body.classList.contains('is-recover')) {
          this.body.classList.add('is-recover');
        }
      } else {
        this.body.classList.remove('is-recover');
      }
    }
  }

  window.MainAccountLogin = MainAccountLogin;

  customElements.define('main-account-login', MainAccountLogin);
}
